export default "__VITE_ASSET__oRs7oRuo__"